import { roofsDataType } from './types';

export const initRoofsData: roofsDataType = {
  gambrel: {
    // 1. gambrel - Мансардная
    allValuesEntered: false,
    fields: [
      {
        id: 1,
        name: 'L_kr',
        value: null,
        label: 'Ширина ската',
        prefix: 'L',
        suffix: 'м',
        info: 'Ширина основания крыши без учета свеса.',
      },
      {
        id: 2,
        name: 'B_kr2',
        value: null,
        label: 'Длина ската 1',
        prefix: 'A',
        suffix: 'м',
        info: ' ',
      },
      {
        id: 3,
        name: 'H_p1',
        value: null,
        label: 'Длина ската 2',
        prefix: 'B',
        suffix: 'м',
        info: ' ',
      },
      {
        id: 4,
        name: 'H_p2',
        value: null,
        label: 'Длина ската 3',
        prefix: 'C',
        suffix: 'м',
        info: ' ',
      },
      {
        id: 5,
        name: 'B_kr1',
        value: null,
        label: 'Длина ската 4',
        prefix: 'D',
        suffix: 'м',
        info: ' ',
      },
    ],
  },

  hip: {
    // 2. hip - Вальмовая
    allValuesEntered: false,
    fields: [
      {
        id: 1,
        name: 'L_kr',
        value: null,
        label: 'Ширина ската 1',
        prefix: 'L',
        suffix: 'м',
        info: 'Длина карниза по длинной стороне крыши.',
      },
      {
        id: 2,
        name: 'B_kr',
        value: null,
        label: 'Ширина ската 2',
        prefix: 'M',
        suffix: 'м',
        info: 'Длина карниза по короткой стороне крыши.',
      },
      {
        id: 3,
        name: 'H_p1',
        value: null,
        label: 'Длина ската 1',
        prefix: 'a',
        suffix: 'м',
        info: 'Длина ската трапециевидной грани (от карниза до конька).',
      },
      {
        id: 4,
        name: 'H_p2',
        value: null,
        label: 'Длина ската 2',
        prefix: 'a2',
        suffix: 'м',
        info: 'Длина ската треугольной грани (от карниза до конька).',
      },
      {
        id: 5,
        name: 'L_k',
        value: null,
        label: 'Длина конька',
        prefix: 'k',
        suffix: 'м',
        info: 'Длина ребра, расположенного в месте стыка скатов.',
      },
    ],
  },

  tented: {
    // 3. tented - Шатровая
    allValuesEntered: false,
    fields: [
      {
        id: 1,
        name: 'L_kr',
        value: null,
        label: 'Ширина ската 1',
        prefix: 'L',
        suffix: 'м',
        info: 'Длина карниза по длинной стороне крыши.',
      },
      {
        id: 2,
        name: 'B_kr',
        value: null,
        label: 'Ширина ската 2',
        prefix: 'M',
        suffix: 'м',
        info: 'Длина карниза по короткой стороне крыши.',
      },
      {
        id: 3,
        name: 'H_p1',
        value: null,
        label: 'Длина ската 1',
        prefix: 'a',
        suffix: 'м',
        info: 'Длина ската от карниза длинной стороны до вершины.',
      },
      {
        id: 4,
        name: 'H_p2',
        value: null,
        label: 'Длина ската 2',
        prefix: 'a2',
        suffix: 'м',
        info: 'Длина ската от карниза короткой стороны до вершины.',
      },
    ],
  },

  multipitch: {
    // 4. multipitch - Многоскатная
    allValuesEntered: false,
    fields: [
      {
        id: 1,
        name: 'L_kr',
        value: null,
        label: 'Длина карниза',
        prefix: 'L<sub>кр</sub>',
        suffix: 'м',
        info: 'Длина основания крыши без учета свеса.',
      },
      {
        id: 2,
        name: 'L_k',
        value: null,
        label: 'Длина конька скворечника',
        prefix: 'L<sub>к</sub>',
        suffix: 'м',
        info: 'Длина ребра, расположенного в месте стыка скатов',
      },
      {
        id: 3,
        name: 'B_kr',
        value: null,
        label: 'Ширина фронтона',
        prefix: 'B<sub>кр</sub>',
        suffix: 'м',
        info: 'Ширина основания крыши без учета свеса.',
      },
      {
        id: 4,
        name: 'B_kr2',
        value: null,
        label: 'Ширина фронтона 2',
        prefix: 'B<sub>кр2</sub>',
        suffix: 'м',
        info: 'Ширина основания крыши без учета свеса.',
      },
      {
        id: 5,
        name: 'H_p1',
        value: null,
        label: 'Высота подъема',
        prefix: 'Н<sub>п1</sub>',
        suffix: 'м',
        info: 'Высота подъема (чердака) от точки заложения до конька.',
      },
    ],
  },
  gable: {
    // 5. gable - Двухскатная
    allValuesEntered: false,
    fields: [
      {
        id: 1,
        name: 'L_kr',
        value: null,
        label: 'Длина карниза',
        prefix: 'L<sub>кр</sub>',
        suffix: 'м',
        info: 'Длина основания крыши без учета свеса.',
      },

      {
        id: 2,
        name: 'L_sk1',
        value: null,
        label: 'Длина ската 1',
        prefix: 'L<sub>ск1</sub>',
        suffix: 'м',
        info: 'Длина первого ската',
      },
      {
        id: 3,
        name: 'L_sk2',
        value: null,
        label: 'Длина ската 2',
        prefix: 'L<sub>ск2</sub>',
        suffix: 'м',
        info: 'Длина второго ската',
      },
    ],
  },
};
